<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Ayarlar</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn to="/" class="mr-3" type="button" variant="danger" :size="ButtonSize">
          <i class="material-icons mifix mr-2">arrow_back</i>
          <span class="ml-1">Ana Ekran</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-row class="mx-auto text-center" align-v="center">
      <!-- <b-col
        cols="12"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link
          to="/Settings/General"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        >
          <i class="material-icons mifix mr-2">settings</i> Genel Ayarlar
        </router-link>
      </b-col>-->

      <b-col
        cols="12"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link
          to="/Settings/Places"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        >
          <i class="material-icons mifix mr-2">store</i> Salonlar
        </router-link>
      </b-col>

      <b-col
        cols="12"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link
          to="/Settings/Tables"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        >
          <i class="material-icons mifix mr-2">dashboard</i> Masalar
        </router-link>
      </b-col>

      <b-col
        cols="12"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link
          to="/Settings/Categories"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        >
          <i class="material-icons mifix mr-2">local_pizza</i> Ürün Kategorileri
        </router-link>
      </b-col>

      <b-col
        cols="12"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link
          to="/Settings/Kitchens"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        >
          <i class="material-icons mifix mr-2">restaurant_menu</i> Mutfaklar
        </router-link>
      </b-col>

      <b-col
        cols="12"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link
          to="/Settings/PaymentTypes"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        >
          <i class="material-icons mifix mr-2">credit_card</i> Ödeme Türleri
        </router-link>
      </b-col>

      <!-- <b-col
        cols="12"
        class="noselect px-1 align-items-center"
        v-if="[1].indexOf(User.RoleID) !== -1"
      >
        <router-link
          to="/Settings/Roles"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        ><i class="material-icons mifix mr-2">how_to_reg</i> Yetkiler</router-link>
      </b-col>-->

      <b-col cols="12" class="noselect px-1 align-items-center">
        <router-link
          to="/Settings/ChangePassword"
          class="btn d-block m-0 border-top-0 border-left-0 border-right-0 border-bottom py-3 text-left btn-outline-info align-items-center"
        >
          <i class="material-icons mifix mr-2">vpn_key</i> Şifre Değiştir
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["User", "ButtonSize"])
  }
};
</script>
